"use client";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import Organizationtable from "../../components/ManageOrganization/Organizationtable";

const defaultTheme = createTheme();

const ManageOrganization = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <>
        <div className="ctpl-page-header">
          <div className="ctpl-title-col">
            <h1>Organizations</h1>
            <p>Manage organisations, module access and contact webhooks.</p>
          </div>
        </div>

        <Organizationtable />
      </>
    </ThemeProvider>
  );
};

export default ManageOrganization;